// Fetches the next available booking slot for the given appointment parameters.
import { useQuery } from '@tanstack/react-query'

import type { AppointmentTypeId, ClinicId, UrgencyId } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface UseNextAvailableSlotParams {
  clinicId: ClinicId
  appointmentTypeId: AppointmentTypeId
  staffId?: string | null
  urgencyId?: UrgencyId
  durationMinutes?: number
  enabled: boolean
}

export function useNextAvailableSlot({
  clinicId,
  appointmentTypeId,
  staffId,
  urgencyId,
  durationMinutes,
  enabled,
}: UseNextAvailableSlotParams) {
  const api = useOsApi()

  return useQuery({
    queryKey: [
      'available-slots',
      clinicId,
      appointmentTypeId,
      staffId ?? null,
      staffId ? null : (urgencyId ?? null),
      durationMinutes ?? null,
    ],
    queryFn: async () => {
      const response = await api.get('/appointments/available-slots', {
        query: {
          clinicId,
          appointmentTypeId,
          staffId: staffId ?? undefined,
          urgencyId: staffId ? undefined : urgencyId,
          durationMinutes,
        },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.slots.map((s) => s.start)
    },
    enabled,
    staleTime: 60_000,
  })
}
